import ModalProvider from "contexts/ModalProvider";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

function Layouts({ children }) {
  const stateProfile = useSelector((state) => state.profile.dataUser);
  useEffect(() => {
    document.body.setAttribute("data-theme", "3D");
    
  }, [stateProfile]);
  console.log('stateProfile >>', stateProfile)
  return <ModalProvider>{children}</ModalProvider>;
}

export default Layouts;
